/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Copilot_Readd_TitleInputs */



/**
* | output |
* | --- |
* | "Re-add Compliance Copilot" |
*
* @param {Sub_Addons_Confirm_Copilot_Readd_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_copilot_readd_title = /** @type {((inputs?: Sub_Addons_Confirm_Copilot_Readd_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Copilot_Readd_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance Copilot erneut hinzufügen")
	return /** @type {LocalizedString} */ ("Re-add Compliance Copilot")
});